import React from 'react'

export default function FoodPage () {
  return (
    <div>
      <h1>FoodPage</h1>
      <p>Top best foods</p>
    </div>
  )
}
